import React, { Component } from "react";
import { check } from "@xams-utils/check-types";

// import QRCode from "react-qr-code";

import { MfaVerify } from "../mfa-verify";
import { MfaNumber } from "../mfa-number";

import { MaterialText } from "components/presentation/material-text";

import { api } from "libs/api/api";
import { ENDPOINTS } from "libs/api/constants";
import { MFA_AUTHENTICATION_TYPES } from "constants/multi-factor-authentication";
import { MESSAGE_IDS } from "constants/message-ids";

class MfaAppNotEnabled extends Component {
    state = { qrKey: null, qrUrl: null, qrError: null };

    componentDidMount() {
        const { userId, messages } = this.props;

        api.get(ENDPOINTS.MFA.GET_QR_CODE, { userID: userId })
            .then((response) => {
                const obj = {};
                const parsedResponse = JSON.parse(response);

                if (check.nonEmptyObject(parsedResponse)) {
                    const { secret, url } = parsedResponse;

                    if (check.nonEmptyString(url)) {
                        obj.qrUrl = url;
                    }

                    if (check.nonEmptyString(secret)) {
                        obj.qrKey = secret;
                    }
                }

                if (check.nonEmptyObject(obj)) {
                    this.setState(obj);
                } else {
                    this.setState({
                        qrError: messages[MESSAGE_IDS.MFA.APP_QR_PROBLEM],
                    });
                }
            })
            .catch(() => {
                this.setState({
                    qrError: messages[MESSAGE_IDS.MFA.APP_QR_PROBLEM],
                });
            });
    }

    displayLineTitle() {
        const { classes, title } = this.props;

        return (
            <div className={classes.line}>
                <MaterialText>{title}</MaterialText>
            </div>
        );
    }

    displayLineOne() {
        const { classes, messages } = this.props;
        console.log(MESSAGE_IDS.MFA.APP_NOT_ENABLED_STEP_1);
        console.log(messages[MESSAGE_IDS.MFA.APP_NOT_ENABLED_STEP_1]);

        return (
            <div className={classes.line}>
                <div className={classes.number}>
                    <MfaNumber number={1} />
                </div>
                <MaterialText>
                    {messages[MESSAGE_IDS.MFA.APP_NOT_ENABLED_STEP_1]}
                </MaterialText>
            </div>
        );
    }

    displayLineTwo() {
        const { qrKey } = this.state;
        const { classes, messages } = this.props;
        const stepText = qrKey
            ? messages[MESSAGE_IDS.MFA.APP_NOT_ENABLED_STEP_2].replace(
                  "qrKey",
                  `<span className={classes.key}>${qrKey}</span>`
              )
            : messages[MESSAGE_IDS.MFA.APP_NOT_ENABLED_STEP_2_NO_QR];

        return (
            <div className={classes.line}>
                <div className={classes.number}>
                    <MfaNumber number={2} />
                </div>
                <div style={{ width: "100%" }}>
                    <MaterialText>{stepText}</MaterialText>
                    {this.displayQRCode()}
                </div>
            </div>
        );
    }

    displayLineThree() {
        const { qrKey } = this.state;
        const { userId, orgId, onVerify, classes, rememberMeDays, messages } =
            this.props;
        const verifyProps = {
            userId,
            orgId,
            onVerify,
            enabled: false,
            mfaOption: MFA_AUTHENTICATION_TYPES.APP,
            rememberMeDays,
            messages
        };
        const qrKeyLine = qrKey
            ? messages[MESSAGE_IDS.MFA.APP_NOT_ENABLED_STEP_3_QR_KEY]
            : "";
        const stepText = messages[
            MESSAGE_IDS.MFA.APP_NOT_ENABLED_STEP_3
        ].replace(
            "{qrKeyLine}",
            `<span className={classes.key}>${qrKeyLine}</span>`
        );

        return (
            <div className={classes.line}>
                <div className={classes.number}>
                    <MfaNumber number={3} />
                </div>
                <div>
                    <MaterialText>{stepText}</MaterialText>
                    <div className={classes.verify}>
                        <MfaVerify {...verifyProps} />
                    </div>
                </div>
            </div>
        );
    }

    displayQRCode() {
        const { qrKey, qrUrl } = this.state;
        const { classes } = this.props;

        if (qrUrl) {
            const imgProps = { src: qrUrl };

            return (
                <div className={classes.qrCode}>
                    <img {...imgProps} />
                </div>
            );
        }

        // return (
        //     <div className={classes.qrCode}>
        //         <QRCode
        //             size={256}
        //             style={{ height: "auto", maxWidth: "100%", width: "100%" }}
        //             value={qrKey}
        //             viewBox={`0 0 256 256`}
        //         />
        //     </div>
        // );
    }

    displayError() {
        const { qrError } = this.state;

        return <MaterialText>{qrError}</MaterialText>;
    }

    render() {
        const { qrKey, qrUrl, qrError } = this.state;
        const { messages } = this.props;

        if (check.nonEmptyString(qrError)) {
            return this.displayError();
        }

        if (qrKey === null && qrUrl === null) {
            return (
                <MaterialText>
                    {messages[MESSAGE_IDS.MFA.APP_LOADING_QR]}...
                </MaterialText>
            );
        }

        return (
            <div>
                {this.displayLineTitle()}
                <div>
                    {this.displayLineOne()}
                    {this.displayLineTwo()}
                    {this.displayLineThree()}
                </div>
            </div>
        );
    }
}

export { MfaAppNotEnabled };
